<template>
  <div class="checkbox-large" :class="{ 'selected' : localValue }">
    <vs-checkbox
        v-model="localValue"
        :vs-value="vsValue"
        @change="$emit('changed', $event)"
    >
      <div class="slot-content">
        <slot></slot>
      </div>
    </vs-checkbox>
  </div>

</template>

<script>

export default {
  name: "checkbox-large",
  components: {
  },
  props: {
    value: {
      required: true,
    },
    vsValue: {
    },
  },
  data() {
    return {
      localValue: null,
    }
  },
  watch: {
    value (val) {
      this.localValue = val;
    },
    localValue (newValue) {
      this.$emit('input', newValue);
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/custom/components/variables';

.checkbox-large {
  &.selected {
    .con-vs-checkbox {
      border: solid 2px $secondary;
      background-color: $yellow-light
    }
  }

  .con-vs-checkbox {
    padding: 22px 27px;
    border: solid 2px $grey-light;
    border-radius: 5px;
    height: 108px;

    .slot-content {
      font-size: 13px;
      margin-left: 14px;
    }

    input:checked+.vs-checkbox {
      border: 1px solid $grey-light !important;
    }

    input:checked+.vs-checkbox {
      border: 2px solid $secondary !important;
    }

    .vs-checkbox {
      min-width: 20px;
      min-height: 20px;

      span.vs-checkbox--check,
      span.vs-checkbox--circle {
        border-radius: 0;
      }

      span.vs-checkbox--circle {
        background-color: $grey-lighter;
      }


      span.vs-checkbox--check {
        background-color: $yellow;

        > i {
          color: #000 !important;
        }
      }
    }
  }
}
</style>
